import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button, ButtonType } from 'components/common/Button.component';
import { TextInput } from 'components/common/TextInput.component';
import { formatDate } from 'components/common/calendar/calendarHelpers';

// ─── Types ────────────────────────────────────────────────────────────────────

interface CalendarFooterProps {
    startDate: Date;
    endDate: Date;
    onApply: () => void;
    onCancel: () => void;
    translate?: (key: string) => string;
    langCode: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export const CalendarFooter: React.FC<CalendarFooterProps> = ({
    startDate,
    endDate,
    onApply,
    onCancel,
    translate,
    langCode,
}) => {
    const t = (key: string, fallback: string) => translate?.(key) ?? fallback;

    return (
        <div className="calendar-footer">
            <div className="calendar-footer-dates">
                <TextInput
                    id="calendar-footer-start-date"
                    value={formatDate(startDate, langCode)}
                    readOnly
                    className="calendar-date-value"
                    ariaLabel={t('calendar.startDate', 'Start date')}
                />
                <span className="calendar-footer-arrow" aria-hidden="true">
                    <ArrowRight size={16} />
                </span>
                <TextInput
                    id="calendar-footer-end-date"
                    value={formatDate(endDate, langCode)}
                    readOnly
                    className="calendar-date-value"
                    ariaLabel={t('calendar.endDate', 'End date')}
                />
            </div>
            <div className="calendar-footer-actions">
                <Button
                    type={ButtonType.PRIMARY}
                    onClick={onApply}
                    text={t('calendar.applyDates', 'Apply dates')}
                />
                <Button
                    type={ButtonType.GHOST}
                    onClick={onCancel}
                    text={t('popUp.cancel', 'Cancel')}
                />
            </div>
        </div>
    );
};

export default CalendarFooter;